import CONFIG from './config';

const { host, apiInterface, withData, withId } = CONFIG;

const EXCLUSIVE_PREFIX_URL = `${host}_exclusive`;
const USERS_PREFIX_URL = `${EXCLUSIVE_PREFIX_URL}/users`;

const endpoints = {
  consents: `${USERS_PREFIX_URL}/consents`,
  consentsProduct: `${EXCLUSIVE_PREFIX_URL}/consents/products`,
};

const generateInterface = apiInterface.createGenerator('bukaemas', endpoints);

const interfaces = {
  getConsentProductAgreementLatest: generateInterface('get', 'consentsProduct', {
    withId,
    appendUrl: 'agreements/latest',
  }),

  putUserConsent: generateInterface('put', 'consents', { withData }),
};

export default interfaces;
